export const DEALER_OPTIONS = [
  "id",
  "code",
  "DealerName",
  "INN",
  "country",
  "FO",
  "subject",
  "city",
  "address",
  "regionalServiceManager",
  "regionalSalesManager",
  "birCode",
  "category",
  "status",
];

export const DEALER_OPTIONS_ROLE_SERVICE_USER = ["regionalServiceManager"];
export const DEALER_OPTIONS_ROLE_SALES_USER = ["regionalSalesManager"];

// Поля, для которых в en-локали используется *En-вариант query-переменной
export const ARR_INCLUDE_EN = [
  "DealerName",
  "subject",
  "city",
  "type",
  "country",
  "FO",
  "address",
  "headName",
];
